import React from "react";
import { RemotePaginateSelector } from "../../components/inputs/RemotePaginateSelector";
import { appendQueryParams } from "../../util/api";

const isOptionSelected = (option, values) => {
  return values.some(({ value }) => option.value === value);
};

export const AdministrateSelect = ({ queryParams = {}, resourceUrl = "", ...props }) => {
  return (
    <RemotePaginateSelector
      isClearable
      dataKey="resources"
      isOptionSelected={isOptionSelected}
      valueKey="id"
      searchParam="search"
      labelKey="dashboard_display_name"
      resourceUrl={appendQueryParams(resourceUrl ?? "", queryParams)}
      {...props}
    />
  );
};

export const AdminOptionableSelect = ({ resource, queryParams = {}, ...rest }) => {
  if (rest.labelKey) {
    queryParams.label_attr = rest.labelKey;
  }

  if (rest.valueKey) {
    queryParams.value_attr = rest.valueKey;
  }

  return (
    <AdministrateSelect
      dataKey="resources"
      resourceUrl={`/admin/${resource}/options.json`}
      {...rest}
      valueKey="id"
      labelKey="label"
      queryParams={queryParams}
    />
  );
};
